import {defineMessages} from 'react-intl';

export default defineMessages({
	generalError: {
		id: 'common.error.general',
		defaultMessage: 'Oops! Something went wrong.'
	},
	submitButton: {
		id: 'popups.returnOrder.submitButton',
		defaultMessage: 'Submit'
	},
	INVALID_PRODUCTS: {
		id: 'popups.returnOrder.error',
		defaultMessage: 'The product has already been returned'
	}
});
